// Home.js

import React from "react";

import AdminCalendar from "../../components/AdminCalendar/adminCalendar.js";

import { useCalendarSelections } from "../../hooks/useCalendarSelections.js";

function Calendar() {
 const { selectedDates, addDate, removeDate, clearDates } = useCalendarSelections();

  return (
    <div className="admin-container narrow-container tm-7">

            <AdminCalendar
              selectedDates={selectedDates}
              addDate={addDate}
              removeDate={removeDate}
              clearDates={clearDates}
            />
    </div>
  );

  //
}

export default Calendar;
